// Quotation Mutations

export const setQuotationList = (state, payload) => {
  state.quotationList = payload
}

export const setQuotationInfo = (state, payload) => {
  state.quotationInfo = payload
}
